import { render, staticRenderFns } from "./ad-authorization.vue?vue&type=template&id=1390995f&scoped=true&"
import script from "./ad-authorization.vue?vue&type=script&lang=js&"
export * from "./ad-authorization.vue?vue&type=script&lang=js&"
import style0 from "./ad-authorization.vue?vue&type=style&index=0&id=1390995f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390995f",
  null
  
)

export default component.exports